import { useQuery } from '@tanstack/react-query';
import { listSurahs, getSurah } from '@/lib/queries/surahs';
import type { Surah } from '@/types/domain';

export function useSurahList() {
  return useQuery<Surah[], Error>({
    queryKey: ['surahs', 'list'],
    queryFn: listSurahs,
  });
}

export function useSurah(id: number | null) {
  return useQuery<Surah | null, Error>({
    queryKey: ['surahs', id],
    // Safe to assert non-null: `enabled` gates the call.
    queryFn: () => getSurah(id as number),
    enabled: id !== null && id > 0,
  });
}
